import ExpandableButton from "../../Components/ExpandableButton";
import FileDownloader from "../../Components/FileDownloader";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {
  IOrderFunctions,
  OrderTableSearchParam,
  OrderType,
} from "../../Interfaces/orderInterfaces";
import { TradeTableReport } from "../../Interfaces/tradeTableInterfaces";
import { getTradeTable } from "../../Requests/Order/tradeTableRequests";
import TableTemplate from "../TableTemplate/tableTemplate";
import TradeTableUI from "./TradeTableUI";
import { createContext } from "react";

export const TradeTableContext = createContext({
  orderType: OrderType.BCSOrder,
  orderFunctions: {} as IOrderFunctions,
}); //initial value doesn't matter

interface TradeTableProps {
  searchParam: OrderTableSearchParam;
  orderType: OrderType;
  orderFunctions: IOrderFunctions;
}

const TradeTable = ({
  searchParam,
  orderType,
  orderFunctions,
}: TradeTableProps) => {
  const onTableRowClick = (row: TradeTableReport) => {
    orderFunctions.addOrderFormValuesChangeHandler(
      "buyInsCode",
      row.buyInstrument,
      "sellInsCode",
      row.sellInstrument
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table">
      <div className="mt-2 absolute -left-10 -top-10">
        <ExpandableButton
          toolButton
          title="دانلود فایل"
          btnVariant="outlined"
          children={[
            <FileDownloader getFile={() => orderFunctions.getExcelFile(searchParam)} label="Excel" variant="menu" />,
            <FileDownloader getFile={() => orderFunctions.getAggregateExcelFile(searchParam)} label="Excel تجمیعی" variant="menu" />,
          ]}
          text={<FileDownloadOutlinedIcon fontSize="small" />}
        />
      </div>
      <TableTemplate<OrderTableSearchParam, TradeTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={(
          searchParam,
          offset,
          pageSize,
          sortingType,
          additional,
          axiosOptions
        ) =>
          getTradeTable(
            searchParam,
            offset,
            pageSize,
            orderFunctions,
            sortingType || "",
            additional,
            axiosOptions
          )
        }
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <TradeTableContext.Provider value={{ orderType, orderFunctions }}>
            <TradeTableUI
              reports={reports}
              onAction={onAction}
              onTableRowClick={onTableRowClick}
              sortingType={sortingType}
              setSortingType={setSortingType}
            />
          </TradeTableContext.Provider>
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default TradeTable;
